// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: "linear-gradient(260.66deg, #7742E9 7.06%, #C736EB 92.94%)",
          borderRadius: "44px"
        },
        outlinedInfo:{
          background: "rgba(145, 158, 171, 0.24)",
          color: "rgba(145, 158, 171, 0.8)",
          boxShadow: "none",
        },
        containedError: {
          borderRadius: "44px"
        },
      },
    },
  };
}
